import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { ComboTooFireInsurancePoliciesListResponseDTO } from '../../../../../dtos/bond-insurance-policy-list/interfaces/policy-for-get-bond-insurance-policies-list-response-dto';
import { printPolicyByCombo } from '../../../../../services/fire-insurance-policy';
import {
  successNotification,
  warningNotification
} from '../../../../../services/notification';

export type Props = {
  combo: ComboTooFireInsurancePoliciesListResponseDTO;
};

const FieldDisplay = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div style={{ paddingBottom: '16px' }}>
    <div
      style={{
        fontWeight: 'bold',
        marginBottom: '0.35em',
        color: '#555',
        fontSize: '0.85em',
        textTransform: 'uppercase'
      }}
    >
      {label}
    </div>
    <div style={{ fontSize: '0.95em', wordBreak: 'break-word' }}>
      {value || 'Indisponível'}
    </div>
  </div>
);

export const ComboFireInsuranceDetails = (props: Props) => {
  const { combo } = props;

  async function handleDownloadApolice() {
    warningNotification('Aguarde', 'Estamos localizando sua apólice.');
    try {
      const data = await printPolicyByCombo(combo.ticket_number);
      const linkSource = `data:application/pdf;base64,${data.attachment}`;
      const downloadLink = document.createElement('a');
      const fileName = `apolice_incendio_${data.filename}.pdf`;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      successNotification('Sucesso', 'Download realizado com sucesso!');
    } catch (err) {
      warningNotification(
        'Opss..',
        'Ainda não recebemos essa apólice. A emissão da mesma pode demorar até 30 dias. Tente novamente mais tarde.'
      );
      console.log(err);
    }
  }

  return (
    <div style={{ paddingLeft: '8px', paddingRight: '8px' }}>
      <div style={{ display: 'flex', width: '100%', alignItems: 'flex-end' }}>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="NÚMERO DO TICKET" value={combo.ticket_number} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="PRÊMIO TOTAL" value={combo.total_premium_amount} />
        </div>
        <div style={{ flex: 1, boxSizing: 'border-box', paddingRight: '10px' }}>
          <FieldDisplay label="PARCELAS" value={combo.installments_amount} />
        </div>
        <div style={{ paddingBottom: '16px' }}>
          <Button
            color={'blue'}
            icon
            onClick={handleDownloadApolice}
            type="button"
            title="Imprimir Apólice"
          >
            <Icon name="print" /> Imprimir Apólice
          </Button>
        </div>
      </div>
    </div>
  );
};
